import { IUnknownDeclaration, IUnknownDeclarationFormValues, IUnknownDeclarationPersistence } from '../interfaces';

export class UnknownDeclarationMapper {
  public static toPersistence(values: IUnknownDeclarationFormValues, id?: string | number): Record<string, any> {
    return {
      ...(id != null ? { conflicted_declaration_id: String(id) } : {}),
      user_id: values.userId,
      measure_id: '1',
      state_id: '',
      global_track_code: values.globalTrackCode,
      country_id: values.countryId,
      product_type_id: values.productTypeId,
      quantity: values.quantity,
      weight: values.weight,
      price: values.price,
      delivery_price: values.deliveryPrice,
      shop_name: values.shop,
      descr: values.description,
      type: values.isLiquid ? '1' : '2',
      wardrobe_number: values.wardrobeNumber,
      document_file: values.file,
    };
  }

  public static toDomain(p: IUnknownDeclarationPersistence): IUnknownDeclaration {
    return {
      id: p.id,
      globalTrackCode: p.global_track_code,
      trackCode: p.track_code,
      status: { id: p.state_id, name: p.state_name },
      user: p.user_id ? { id: p.user_id, name: p.user_name ?? '' } : null,
      weight: p.weight ? parseFloat(p.weight) : null,
      price: p.price ? parseFloat(p.price) : null,
      currency: p.currency ?? null,
      deliveryPrice: p.delivery_price ? parseFloat(p.delivery_price) : null,
      height: p.height ? parseFloat(p.height) : null,
      width: p.width ? parseFloat(p.width) : null,
      depth: p.depth ? parseFloat(p.depth) : null,
      voen: p.voen ?? null,
      shop: p.shop_name ?? '',
      quantity: p.quantity ?? null,
      type: p.type === 1 ? 'liquid' : 'other',
      description: p.descr ?? '',
      file: p.document_file ?? null,
      paid: !!p.payed,
      approved: !!p.customs,
      customs: p.customs ?? null,
      returned: !!p.return,
      read: !!p.is_new,
      countryId: p.country_id ?? null,
      wardrobeNumber: p.wardrobe_number ?? null,
      productType: p.product_type_id ? { id: p.product_type_id, name: p.product_type_name ?? '' } : null,
      planCategory: p.tariff_category_id ? { id: p.tariff_category_id, name: p.tariff_category_name ?? '' } : null,
      parcel: p.box ? { id: p.box } : null,
      basket: p.basket_id || p.basket_name ? { id: p.basket_id ?? '', name: p.basket_name ?? '' } : null,
      box: p.container_id ? { id: p.container_id, name: p.container_name ?? '' } : null,
      lastBox: p.container_id_tmp ? { id: p.container_id_tmp, name: p.container_name_tmp ?? '' } : null,
      branch: p.branch_id ? { id: p.branch_id, name: p.branch_name ?? '' } : null,
      flight: p.flight_name ? { id: 0, name: p.flight_name } : null,
      deliveryPoint: p.delivery_point_id ? { id: p.delivery_point_id, name: p.delivery_point_name ?? '' } : null,
      partnerName: p.partner_name ?? '',
      partnerId: p.partner_id ?? null,
      handoverTaskId: p.handover_task_id ?? null,
      createdAt: p.created_at,
      deliveredAt: p.delivered_at ?? null,
      trendyol: p.trendyol ?? null,
      couponId: p.coupon_id ?? null,
      editable: !!p.editable,
      causerId: p.causer_id ?? null,
      trendyolLogs: p.trendyol_logs
        ? {
            name: p.trendyol_logs.name ?? '',
            category: p.trendyol_logs.category ?? '',
            type: p.trendyol_logs.type ?? '',
            state: p.trendyol_logs.state ?? '',
            isLiquid: p.trendyol_logs.is_liquid === 1,
            isDoor: p.trendyol_logs.is_door === 1,
            isMicro: p.trendyol_logs.is_micro === 1,
            isDeclared: p.trendyol_logs.is_declared === 1,
            invoice: {
              invoicePrice: p.trendyol_logs.invoice?.invoice_price ?? 0,
              invoiceUrl: p.trendyol_logs.invoice?.invoice_url ?? '',
            },
            products: { sku: p.trendyol_logs.products?.sku ?? '' },
            trendyolDeliveryNumber: p.trendyol_logs.trendyol_delivery_number ?? '',
            unitPrice: p.trendyol_logs.unit_price ?? '',
            quantity: p.trendyol_logs.quantity ?? 0,
            parcelId: p.trendyol_logs.parcel_id ?? '',
            volume: p.trendyol_logs.volume ?? 0,
            fullName: p.trendyol_logs.full_name ?? '',
            pinCode: p.trendyol_logs.pin_code ?? '',
            comment: p.trendyol_logs.comment ?? '',
            phoneNumber: p.trendyol_logs.phone_number ?? '',
            createdAt: p.trendyol_logs.created_at ?? '',
            emailAddress: p.trendyol_logs.email_address ?? '',
            zipCode: p.trendyol_logs.zip_code ?? '',
            warehouseId: p.trendyol_logs.warehouse_id ?? '',
            domesticCargoCompany: p.trendyol_logs.domestic_cargo_company ?? '',
            city: p.trendyol_logs.city ?? '',
            smsCount: p.trendyol_logs.sms_count ?? 0,
            smsDate: p.trendyol_logs.sms_date ?? null,
            shippingAddress: p.trendyol_logs.shipping_address ?? '',
            declarationId: p.trendyol_logs.declaration_id ?? '',
            weight: p.trendyol_logs.weight ?? '',
            uid: p.trendyol_logs.uid?.join(', ') ?? '',
            customsStatus: p.trendyol_logs.customs_status ?? '',
            barcode: p.trendyol_logs.barcode ?? '',
          }
        : null,
    };
  }
}
